module.exports = __webpack_public_path__ + "static/media/netf-clone.ae1cb80b.png";